import React from "react";

export default function Prestations() {
  return (
    <div className="m-auto text-center   mt-28">
      <section className="px-4">
        <h1>Cours particuliers</h1>
        <p>Tous niveaux, en français et/ou en anglais</p> <br />
        <p>
          <br />
          Que vous soyez débutant ou expérimenté, je propose des cours sur
          mesure, adaptés à vos objectifs. <br /> <br />
          Préparez une chorégraphie pour une ouverture de bal, un événement
          spécial comme un enterrement de vie de jeune fille <br /> ou <br />{" "}
          apprenez les bases pour vous sentir à l’aise en soirée dansante.
        </p>
      
        <div className="my-28 md:w-1/2 m-auto space-y-8">
          <h1>Cours de Team Building en entreprise</h1>
          <p>
            Utilisez la danse pour renforcer la cohésion et l’esprit d’équipe.
            Ces sessions offrent une expérience conviviale et stimulante pour
            renforcer les liens au sein de votre groupe.
          </p>
        </div>
        <div className="my-28 md:w-1/2 m-auto space-y-8">
          <h1>Progression Rapide et Méthode I.D.T.A</h1>
          <p>
            Pour ceux qui ont déjà quelques bases et veulent progresser,
            j’enseigne selon la méthode I.D.T.A (International Dancing Teachers
            Association) de Londres, en danses latines, standards, et
            ladystyling en salsa et bachata. Ces cours s’adaptent aux amateurs
            et aux compétiteurs.
          </p>
        </div>
        <div className="my-28 md:w-1/2 m-auto space-y-8">
          <h1>Mon Approche</h1>
          <p>
            Je fonde mon enseignement sur : efficacité, simplicité, humour,
            plaisir et bienveillance. Mon but est de vous permettre un
            épanouissement personnel par la danse. Avec une pédagogie affinée,
            j’allie créativité et recentrage sur soi pour révéler votre
            potentiel unique. Vous apprendrez des concepts essentiels comme le
            guidage, la posture, l’écoute musicale, ainsi que des techniques
            pour reconnaître le rythme et vous sentir à l’aise dans toute
            situation dansante.
          </p>
        </div>

     
      </section>

      <section>
      <div className="flex-col md:flex bg shado flex-col flex-wrap justify-center items-center   m-auto my-16 space-y-8  text-white md:w-1/2 lg:w-1/2 rounded p-4">
          <h1 className="text-center ">Tarifs des cours</h1>
         
            <div>Cours particulier (1 ou 2 personnes) : 50€/heure</div>
            <div>Cours en webcam : 35€/heure</div>
            <div>Cours en entreprise : sur devis</div>
        
        </div>
        <div className="flex-col md:flex bg shado flex-col flex-wrap justify-center items-center   m-auto my-16 space-y-8 text-white w-5/6 md:w-1/2 lg:w-1/2 rounded p-4">
          <h1 className="text-center">Conditions supplementaires</h1>
        
            <div>
              Frais de déplacement : +10€ hors de Neuvilly,  ajustés selonla distance
            </div>
            <div>Studio de danse : les frais de location sont ajoutés</div>
       
        </div>
      </section>
    </div>
  );
}
